// One active read per session; an older response must not change the new session.
export function createSessionLoader(request) {
  let generation = 0, pending = null, cancel = null;
  function invalidate() {
    generation += 1;
    if (cancel) cancel('Session changed');
    cancel = null;
    pending = null;
  }
  function load({force = false, onStart, onSuccess, onFailure} = {}) {
    if (pending && !force) return pending;
    invalidate();
    const current = generation;
    if (onStart) onStart();
    const started = request();
    cancel = started.cancel || null;
    pending = Promise.resolve(started.promise || started)
      .then(response => {
        if (current !== generation) return {stale: true};
        if (onSuccess) onSuccess(response);
        return {stale: false, response};
      }).catch(error => {
        if (current !== generation) return {stale: true};
        if (onFailure) onFailure(error);
        return {stale: false, error};
      }).finally(() => {
        if (current === generation) {pending = null; cancel = null;}
      });
    return pending;
  }
  return {load, invalidate};
}

export function postLoginRoute(router, profile, redirect) {
  if (!profile || !profile.id) return {path: '/onboarding'};
  if (typeof redirect === 'string' && redirect.startsWith('/') &&
      !redirect.startsWith('//') && !redirect.includes('\\')) {
    const resolved = router.resolve(redirect).route;
    if (resolved.matched.some(record => record.meta.requiresAuth)) return redirect;
  }
  return {name: 'Index'};
}
